import React, { useContext } from "react";

import KineticaLogo from "../../images/logo.svg";
import Error404 from "../../images/error_404.png";
import { AlertContext } from "../../constants";

const NotFound = () => {
  const alerts = useContext(AlertContext);

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        paddingTop:
          alerts.length > 0 ? "calc(50% - 340px)" : "calc(50% - 260px)",
        textAlign: "center",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img
          src={KineticaLogo}
          alt="Kinetica Logo"
          style={{ height: "40px", position: "relative", top: "-3px" }}
        />
        <h1
          style={{
            color: "rgb(181, 255, 61)",
            fontSize: "34px",
            fontWeight: "200",
          }}
        >
          Cloud
        </h1>
      </div>
      <img
        src={Error404}
        style={{ opacity: 0.25, height: 200 }}
        alt="Error 404"
      />
    </div>
  );
};

export default NotFound;
